import { Controller } from "react-hook-form";
import { SelectField } from "../../ui";
import { TypeBondEnum } from "../../../utils/enum/enum";

interface SelectTypeBondProps {
    name: string;
    methods: any;
    disabled?: boolean;
    required?: boolean;
    label?: string;
}

export function SelectTypeBond({
    name,
    methods,
    disabled = false,
    required = false,
    label = "Selecione um regime de Trabalho",
}: SelectTypeBondProps) {
    return (
        <Controller
            name={name}
            control={methods.control}
            render={({ field, formState: { errors } }) => (
                <SelectField
                    label={label}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    required={required}
                    disabled={disabled}
                    error={!!errors[name as keyof typeof errors]}
                >
                    <option value={TypeBondEnum.CLT}>CLT</option>
                    <option value={TypeBondEnum.MEI}>MEI</option>
                    <option value={TypeBondEnum.SN}>Simples Nacional</option>
                </SelectField>
            )}
        />
    );
}
